module.exports = __webpack_public_path__ + "media/images/battery-orange-2bf40ed6bf9e825fbac61fdbc3c624af.png";